module.exports = __webpack_public_path__ + "static/media/discount.ee4ab9c4.svg";